import styled, { keyframes, css } from "styled-components";
import { userContext } from "../context/index";
import returnStr from "../vocabs";
import Home_back from "./../../assets/images/home.jpg";
import back_pattern from "../../assets/images/back.png";
import { motion } from "framer-motion";
import Logo from "../../assets/images/logo.png";
import Loading_gif from "../../assets/images/loading.gif";
import { useState, useEffect, useContext } from "react";
import Typist from "react-typist";
import passwordLock from "../../assets/images/passwordLock.png";
import showPassword from "../../assets/images/showPassword.png";
import username from "../../assets/images/username.png";
import bell from "../../assets/images/bell.png";
import menu from "../../assets/images/menu.png";
import signal from "../../assets/images/signal.png";
import Close from "../../assets/images/close.png";
import Left from "../../assets/images/left.png";
import Chart from "react-apexcharts";
import CO2 from "../../assets/images/co2.png";
import Humidity from "../../assets/images/humidity.png";
import InsideTemp from "../../assets/images/insideTemp.png";
import OnLamp from "../../assets/images/Lamp.png";
import OffLamp from "../../assets/images/offLamp.png";
import Fan from "../../assets/images/fan.png";
import { io } from "socket.io-client";
import B000 from "../../assets/images/1x/000.png";
import B001 from "../../assets/images/1x/001.png";
import B010 from "../../assets/images/1x/010.png";
import B100 from "../../assets/images/1x/100.png";
import B011 from "../../assets/images/1x/011.png";
import B111 from "../../assets/images/1x/111.png";
import B101 from "../../assets/images/1x/101.png";
import B110 from "../../assets/images/1x/110.png";
const persianReturner = (num) => {
  if (num) {
    let persianNumbers = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
    return [...num.toString()]
      .map((c) => persianNumbers[parseInt(c)] || c)
      .join("");
  }
};
const Main = styled.div({
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  width: "100%",
  height: "fit-content",
  scrollSnapType: "y mandatory",
  scrollBehavior: "smooth",
  position: "relative",
});

const Hl = styled.section({
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-start",
  alignItems: "center",
  width: "100%",
  height: "100vh",
  scrollSnapAlign: "center",
  position: "relative",
  "&> .hide": {
    "@media (max-width:889px)": {
      display: "none",
    },
  },
  "&> .articleShow": {
    "@media (max-width:889px)": {
      display: "flex",

      animation: () =>
        css`
          ${FadeIn} 1s linear 1
        `,
    },
  },
  "&> .mo": {
    "@media (max-width:889px)": {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      background: (p) => p.bgColor || "white",
      "&> .bg": {
        display: "none",
      },
      "&> .mobile": {
        position: "relative",
        top: "0",
        right: "unset",
        zIndex: "9",
        height: "calc( 100% - 40px)",
        width: "calc( 100% - 40px)",
        maxWidth: "350px",
        maxHeight: "650px",
        direction: "rtl",
      },
    },
  },
});

const FadeIn = keyframes`
from {
  opacity: 0;
}
to {
  opacity: 1;
}
 

`;

const Holder = (props) => {
  const {
    desc,
    step,
    title,
    logo,
    appLogo,
    mobileColor,
    hieght,
    id,
    children,
    iconColor,
    isTitleCenter = false,
    mobileComponent,
    statusBar,
    style,
    timer,
  } = props;

  const [isMobile, setIsMobile] = useState(true);
  const [effected, setEffected] = useState(false);

  useEffect(() => {
    if (!effected && props?.timer && step == id) {
      setEffected(true);
      let tt = setTimeout(() => {
        clearTimeout(tt);
        setIsMobile(false);
      }, props?.timer);

      let timer = setTimeout(() => {
        clearTimeout(timer);
        window.location.replace(`/#${parseInt(id) + 1}`);
      }, props?.timer + 3000);
    }
  }, [props?.timer, props?.id, props?.step]);

  return (
    <Hl bgColor={mobileColor} style={style} id={id} hieght={hieght}>
      <Cn
        className={isMobile ? "hide" : "articleShow"}
        isTitleCenter={isTitleCenter}
        desc={desc}
        title={title}
        icon={{ src: logo, appLogo: appLogo, color: iconColor }}
      >
        {children}
      </Cn>
      {!isTitleCenter ? (
        <Mobile
          className={isMobile ? "mo" : "hide"}
          statusBar={statusBar}
          bgColor={mobileColor}
          step={step}
        >
          {step == id ? mobileComponent : "none"}
        </Mobile>
      ) : null}

      <ScrollDown color={mobileColor} id={id} />
    </Hl>
  );
};
const Cn_Holder = styled.article({
  backgroundImage: `url(${back_pattern})`,
  backgroundSize: "200px 100px",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "20% 10%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: (p) => (p.isTitleCenter ? "center" : "flex-start"),
  width: (p) => (p.isTitleCenter ? "100%" : "70%"),
  height: "100%",
  "& .title": {
    fontFamily: "text",
    fontWeight: "bold",
    fontSize: "20px",
  },
  "& .desc": {
    fontFamily: "text",
    fontSize: "16px",
    textAlign: "justify",
    maxWidth: "450px",
    color: "var(--gray)",
    marginTop: "10px",
    fontWeight: "bold",
  },
  "& .logo": {
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundImage: (p) => `url(${p.icon.src})`,
    height: "50px",
    width: "50px",
    backgroundSize: "35px 35px",
    backgroundColor: (p) => (p.icon.appLogo ? "#f9f8f8" : "none"),
    borderRadius: (p) => (p.icon.appLogo ? "10px" : "none"),
    marginBottom: (p) => (p.icon.appLogo ? "20px" : "none"),
    boxShadow: (p) =>
      p.icon.appLogo ? `0 0 33px 1px ${p.icon.color} ` : "none",
  },

  "@media (max-width:950px)": {
    margin: "0 30px",
    width: "100%",
    alignItems: "center",
    "& .desc": {
      textAlign: "center",
    },
  },
});
const Cn = (props) => {
  const { icon, title, desc, isTitleCenter, className } = props;
  const { isFa } = useContext(userContext);

  return (
    <Cn_Holder
      style={
        isFa
          ? { marginRight: isTitleCenter ? "0" : "100px" }
          : { marginLeft: isTitleCenter ? "0" : "100px" }
      }
      isFa={isFa}
      className={className}
      icon={icon}
    >
      <div className="logo"></div>
      <h2 className="title">{title}</h2>
      <p className="desc">{desc}</p>
      {props.children}
    </Cn_Holder>
  );
};

const Gtp = styled.form({
  width: "calc( 100% - 60px )",
  maxWidth: 410,
  position: "relative",
  //   "@media (max-width:950px)": {
  // marginLeft:20

  //   },
  "& input ": {
    width: "100%",
    height: "40px",
    fontFamily: "title",
    fontSize: 15,
    background: "var(--back)",
    border: "none",
    borderRadius: "15px",
    padding: "5px 20px",
    boxShadow: `0 0 19px 1px #c4c4c4 `,
    margin: "20px 0",
  },
  "& button ": {
    background: "var(--blue)",
    color: "white",
    fontFamily: "title",
    border: "none",
    borderRadius: "15px",
    padding: "0px 20px",
    position: "absolute",
    height: "44px",
    fontSize: "14px",
    top: 23,

    cursor: "pointer",
    background: (p) => (p.submited ? "var(--green)" : "var(--blue)"),
  },
  "& button:hover ": {
    filter: "grayscale(0.2)",
  },
});
const GetPhoneNumber = () => {
  const [submited, setSubmidet] = useState(false);
  const { isFa } = useContext(userContext);
  const vocabs = (str) => {
    return returnStr(str, isFa);
  };
  return (
    <Gtp
      action="https://nirooban.com/form"
      onSubmit={(e) => {
        setSubmidet(true);
      }}
      target="dummyframe"
      method="post"
    >
      <iframe
        name="dummyframe"
        id="dummyframe"
        style={{ display: "none" }}
      ></iframe>

      <input
        required
        name="phone"
        type="text"
        placeholder={vocabs("enterPhoneNumber")}
      />
      <button
        submited={submited}
        style={!isFa ? { right: "-37px" } : { left: "-37px" }}
      >
        {submited ? vocabs("sent") : vocabs("callMe")}
      </button>
    </Gtp>
  );
};

const DH = styled.section({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  position: "fixed",
  top: "45%",
  transition: "200ms",
  zIndex: "9",
  "& span": {
    background: "rgba(212, 211, 211, 0.59)",
    width: "10px",
    height: "10px",
    borderRadius: "100%",
    margin: "2px 0",
    opacity: "0.9",
    cursor: "pointer",
  },
  "& .active": {
    background: "white",
    boxShadow: `0 0 19px 0px #c4c4c4 `,
    cursor: "default",
  },
  "@media (max-width:400px)": {
    display: "none",
  },
  "& .lang": {
    color: "white",
    marginTop: "20px",
    cursor: "pointer",
  },
});
const Dots = (props) => {
  const { step } = props;
  const { isFa, setIsFa } = useContext(userContext);
  return (
    <DH style={isFa ? { left: 10 } : { right: 10 }}>
      <span
        onClick={() => {
          window.location.replace("/#0");
        }}
        className={step == 0 ? "active" : "none"}
      ></span>
      <span
        onClick={() => {
          window.location.replace("/#1");
        }}
        className={step == 1 ? "active" : "none"}
      ></span>
      <span
        onClick={() => {
          window.location.replace("/#2");
        }}
        className={step == 2 ? "active" : "none"}
      ></span>
      <span
        onClick={() => {
          window.location.replace("/#3");
        }}
        className={step == 3 ? "active" : "none"}
      ></span>
      <span
        onClick={() => {
          window.location.replace("/#4");
        }}
        className={step == 4 ? "active" : "none"}
      ></span>
      <span
        onClick={() => {
          window.location.replace("/#5");
        }}
        className={step == 5 ? "active" : "none"}
      ></span>
      <span
        onClick={() => {
          window.location.replace("/#6");
        }}
        className={step == 6 ? "active" : "none"}
      ></span>

      <b onClick={() => setIsFa(!isFa)} className="lang">
        {isFa ? " 🇺🇸" : "🇮🇷 "}
      </b>
    </DH>
  );
};
const MCn = styled.div({
  height: "100%",
  width: "50%",
  position: "relative",
  transition: "500ms",
  direction: "ltr",

  "& > .bg": {
    height: "100%",
    width: "70%",
    background: (p) => p.bgColor,
  },

  "& > .mobile": {
    direction: "rtl",
    position: "absolute",
    height: "554.78px",
    transform: (p) => `scale(${p.scale})`,
    // maxHeight: "550px",
    width: "300px",
    // maxWidth: "300px",
    background: "black",
    top: "calc( 100% - 85vh)",
    right: "10px",
    borderRadius: "50px",
    padding: "10px 8px",
    top: (p) => `${(window.innerHeight - 550 * p.scale) / 2}px`,
    boxShadow: `0 0 19px 1px  rgba(24, 23, 23, 0.2)`,
    "& .noch": {
      height: 40,
      width: "100%",
      borderRadius: " 40px 40px 0 0",
      display: "flex",
      background: (p) => p.statusBar,
      flexDirection: "row",
      justifyContent: "center",
      transition: "1000ms",
      "& .center ": {
        width: "60%",
        height: "80%",
        background: "black",
        borderRadius: " 0 0 22px 22px ",
      },
      "& .right": {
        width: "20%",
        height: "100%",
      },
      "& .left": {
        width: "20%",
        height: "100%",
      },
    },
    "& .cn": {
      background: "white",
      flex: 1,
      height: "calc( 100% - 40px )",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "0 0 40px 40px",
      overflow: "hidden",
    },
  },

  // "@media (max-width:950px)": {
  //   display: "none",
  //   width: "0",
  // },
});

const Mobile = (props) => {
  const { step, bgColor, statusBar } = props;
  const [effected, setEffected] = useState(false);
  const [scale, setScale] = useState(1);
  const { isFa } = useContext(userContext);

  useEffect(() => {
    if (!effected) {
      setEffected(true);
      if (window.innerWidth > 889) {
        setScale((window.innerHeight * 554.78) / 722 / 554.78);
      } else {
        setScale(1);
      }
      window.addEventListener("resize", (e) => {
        if (window.innerWidth > 889)
          setScale((window.innerHeight * 554.78) / 722 / 554.78);
      });
    }
  }, [scale]);
  return (
    <MCn
      className={props.className}
      scale={scale}
      statusBar={statusBar}
      bgColor={bgColor}
    >
      <div
        style={!isFa ? { position: "absolute", right: 0 } : {}}
        className="bg"
      ></div>
      <div style={isFa ? { right: 10 } : { left: 10 }} className="mobile">
        <div className="noch">
          <div className="right"></div>
          <div className="center"></div>
          <div className="left"></div>
        </div>
        <div style={{ direction: isFa ? "rtl" : "ltr" }} className="cn">
          {props.children}
        </div>
      </div>
    </MCn>
  );
};

const HlfMb = styled.section({
  width: "calc( 100% - 16px )",
  direction: "rtl",
  height: "100%",
  maxHeight: "350px",
  borderTopLeftRadius: "50px",
  borderTopRightRadius: "50px",
  background: "black",
  padding: "10px 8px",
  paddingBottom: "0",

  "& .noch": {
    height: 50,
    width: "100%",
    borderRadius: " 40px 40px 0 0",
    display: "flex",
    background: (p) => p.statusBar || "var(--blue)",
    flexDirection: "row",
    justifyContent: "center",
    "& .center ": {
      width: "60%",
      height: "80%",
      background: "black",
      borderRadius: " 0 0 22px 22px ",
    },
    "& .right": {
      width: "20%",
      height: "100%",
    },
    "& .left": {
      width: "20%",
      height: "100%",
    },
  },
  "& .cn": {
    background: "white",
    flex: 1,
    height: "calc( 100% - 50px )",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    overflowY: "hidden",
  },
});
const HalfMobile = (props) => {
  const { statusBar } = props;
  return (
    <HlfMb statusBar={statusBar}>
      <div className="noch">
        <div className="right"></div>
        <div className="center"></div>
        <div className="left"></div>
      </div>
      <div className="cn">{props.children}</div>
    </HlfMb>
  );
};

const SmHolder = styled.section({
  position: "relative",
  display: "flex",
  flexDirection: "row",
  justifyContent: "Center",
  alignItems: "center",
  width: "100%",
  height: "100vh",
  scrollSnapAlign: "center",
  backgroundImage: `url(${back_pattern})`,
  backgroundSize: "200px 100px",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "20% 10%",
  "& .motion": {
    width: "calc( 100% - 20px )",
    maxWidth: "350px",
    height: "100%",
    maxHeight: "350px",
    margin: "0 10px",
  },
  "& .content": {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    alignItems: "center",
    flex: 1,
    marginBottom: "30px",
  },
  "& .qr": {
    height: "100%",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "Center",
    alignItems: "center",
    "& .title": {
      fontFamily: "title",
      fontWeight: "bold",
      color: "color",
      fontSize: "22px",
      marginTop: "10px",
    },
    "& .desc": {
      fontFamily: "title",
      color: "black",
      fontSize: "18px",
      maxWidth: "480px",
      width: "calc( 100% - 20px)",
      textAlign: "center",
      margin: "10px  ",
    },
  },
});
const SmartHome = (props) => {
  const { bg, step, id, mobileComponent, statusBar, style } = props;
  const { isFa } = useContext(userContext);

  const vocabs = (str) => {
    return returnStr(str, isFa);
  };
  return (
    <SmHolder style={style} id={id} bg={bg}>
      <div className="qr">
        <div className="content">
          <span className="title">{vocabs("s5_title")}</span>
          <span className="desc">{vocabs("s5_description")}</span>
        </div>
        <motion.div
          className="motion"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.9 }}
        >
          {id == step ? (
            <HalfMobile statusBar={statusBar}>{mobileComponent}</HalfMobile>
          ) : (
            ""
          )}
        </motion.div>
      </div>
    </SmHolder>
  );
};

const IotHolder = styled.section({
  position: "relative",
  display: "flex",
  flexDirection: "row",
  justifyContent: "Center",
  alignItems: "center",
  width: "100%",
  height: "100vh",
  scrollSnapAlign: "center",
  backgroundImage: (p) => `url(${p.bg})`,
  backgroundSize: "cover",
  backgroundPosition: "50%",
  "& .content": {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    alignItems: "center",
    flex: 1,
    marginBottom: "30px",
    textAlign: "center",
  },
  "& .qr": {
    backdropFilter: "blur(5px)",
    background: "#0000008a",
    height: "100%",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "Center",
    alignItems: "center",
    "&>.qr-motion": {
      height: "100%",
      maxWidth: "350px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "Center",
      alignItems: "center",
    },
    "& .title": {
      fontFamily: "subject",
      fontWeight: "bold",
      color: "white",
      fontSize: "28px",
    },
    "& .desc": {
      fontFamily: "title",
      fontWeight: "bold",
      color: "white",
      fontSize: "20px",
      maxWidth: "480px",

      width: "calc( 100% - 20px)",
      textAlign: "center",
      margin: "10px 0 ",
    },
    "& .arrow": {
      border: "solid black",
      borderWidth: "0 5px 5px 0",
      display: "inline-block",
      padding: "5px",
    },
    "& .up": {
      transform: "rotate(-135deg)",
    },
  },
  "& .mobileCn": {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "center",
    height: "100%",
    width: "100%",
    "&> .header": {
      height: "50px",
      background: "var(--blue)",
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
      width: "100%",
      marginBottom: "15px",
      "&>span": {
        color: "white",
        fontFamily: "title",
        margin: "0 10px",
        fontSize: "18px",
      },
    },
  },
});
const socket = io("https://nirooban.com");

const Iot = (props) => {
  const pictures = [B000, B001, B010, B100, B011, B111, B101, B110];
  const { id } = props;
  const [qr, setQr] = useState();
  const [bg, setBg] = useState(Home_back);
  const [connect, setConnect] = useState(false);
  const [effected, setEffected] = useState(false);
  const { isFa } = useContext(userContext);

  const vocabs = (str) => {
    return returnStr(str, isFa);
  };
  useEffect(() => {
    if (!effected) {
      setEffected(true);
      pictures.forEach((picture) => {
        const img = new Image();
        img.src = picture;
      });
    }
  });
  useEffect(() => {
    socket.on("qr", (msg) => {
      setQr(msg);
    });
    socket.on("cmd", (msg) => {
      if (msg.connect) {
        setConnect(true);
        setBg(B000);
      } else if (msg.value) {
        let v = msg.value;
        if (v == "000") {
          setBg(B000);
        } else if (v == "001") {
          setBg(B001);
        } else if (v == "010") {
          setBg(B010);
        } else if (v == "100") {
          setBg(B100);
        } else if (v == "101") {
          setBg(B101);
        } else if (v == "110") {
          setBg(B110);
        } else if (v == "111") {
          setBg(B111);
        } else if (v == "011") {
          setBg(B011);
        }
      }
    });
  }, [bg]);
  return (
    <IotHolder style={props.style} id={id} bg={bg}>
      {connect != "animationFinished" ? (
        <div className="qr">
          <motion.div
            className="qr-motion"
            onAnimationComplete={() => {
              if (connect) setConnect("animationFinished");
            }}
            initial={{ y: 0 }}
            animate={!connect ? { y: 1, scale: 1 } : { y: 600, scale: 0.5 }}
            transition={{ duration: 0.9 }}
          >
            <div className="content">
              <span className="title"> {vocabs("s6_title")} </span>
              <span className="desc">{vocabs("s6_description")} </span>
            </div>
            <HalfMobile>
              <div className="mobileCn">
                <div
                  style={{ direction: isFa ? "rlt" : "ltr" }}
                  className="header"
                >
                  <span>{vocabs("s5_title")}</span>
                </div>
                <img src={qr} height={"150px"} width="150px" alt="" />
                <i style={{ opacity: "1" }} className="arrow up"></i>

                <i style={{ opacity: "0.5" }} className="arrow up"></i>
                <i style={{ opacity: "0.3" }} className="arrow up"></i>
              </div>
            </HalfMobile>
          </motion.div>
        </div>
      ) : null}{" "}
    </IotHolder>
  );
};

const W = styled.div({
  height: 50,
  width: "100%",
  background: "var(--red)",
  position: "fixed",
  top: 0,
  zIndex: 99999,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  boxShadow: `0 0 33px 1px var(--red)`,
  "& span": {
    fontFamily: "title",
    fontWeight: "bold",
    color: "white",
  },
});
const Warning = (props) => {
  return (
    <W>
      <span>این صفحه در حال ساخت هست. ;)</span>
    </W>
  );
};

const SHl = styled.div({
  flex: 1,
  background: (p) => p.bg || "var(--blue)",
  width: "100%",
  display: "flex",
  justifyContent: (p) => p.jc || "flex-start",
  alignItems: (p) => p.ai || "flex-start",
  flexDirection: (p) => p.fd || "column",
  transition: "1000ms",
  position: "relative",
});

const Sc1Cn = styled.div({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  height: "100%",
  postion: "realtive",
  "& .motion": {},
  "&  .motion>.logo": {
    height: "50px",
  },
  "& .loading": {
    marginTop: "10vh",
    height: "30px",
    position: "absolute",
    bottom: "50px",
    opacity: "0.5",
  },
  "& .spanMotion": {
    flexDirection: "column",
    display: "flex",
    position: "absolute",
    bottom: "30px",
  },
  "& .titleMotion": {
    flexDirection: "column",
    display: "flex",
  },
  "& .spanMotion>.span": {
    fontFamily: "text",
    fontWeight: "bold",
    textAlign: "center",
    marginTop: "50px",
    fontSize: "15px",
  },
  "& .titleMotion>span": {
    fontFamily: "title",
    fontWeight: "bold",
    textAlign: "center",
    color: "var(--blue)",
    marginBottom: "10vh",
    display: "block",
    fontSize: "18px",
  },
});

const Sc1CnLogin = styled.div({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  height: "100%",
  width: "100%",
  background: "white",
  position: "relative",
  "& .logo": {
    height: "40px",
    width: "40px",
    position: "absolute",
    top: "10%",
    background: "var(--back)",
    borderRadius: "100%",
    padding: "10px",
    boxShadow: `0 0 33px 1px var(--blue) `,
  },
  "& .inputHolder": {
    position: "relative",
    background: "white",
    borderRadius: "15px",
    margin: "10px",
    width: "calc( 100% - 60px)",
    height: 50,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    padding: "10px 10px",
    boxShadow: "0 0 19px 1px rgb(24 23 23 / 20%)",
    "& .top": {
      fontFamily: "title",
      fontWeight: "bold",
      color: "#c8c8c8",
      fontSize: "14px",
    },
    "& .in ": {
      width: "100%",
      display: "flex",
      flexDirection: "row",
    },
    "& .in > .Typist": {
      width: "100%",
      fontFamily: "title",
      fontWeight: "bold",
      textAlign: "left",
      position: "relative",
      paddingLeft: "35px",
    },
    "& .in > .icon": {
      height: "20px",
      width: "20px",
      position: "absolute",

      backgroundPosition: "center",
      backgroundSize: "contain",
      opacity: "0.7",
    },
    "& .in > .username": {
      left: "20px",
      backgroundImage: `url(${username})`,
    },
    "& .in > .showpassword": {
      right: "20px",
      backgroundImage: `url(${showPassword})`,
      cursor: "pointer",
    },
    "& .in > .password": {
      left: "20px",
      backgroundImage: `url(${passwordLock})`,
    },
  },
  "& .btn": {
    background: "var(--blue)",
    height: "50px",
    color: "white",
    border: "none",
    borderRadius: "15px",
    width: "calc( 100% - 40px)",
    fontFamily: "title",
    fontWeight: "bold",
    marginTop: "20px",
    position: "absolute",
    bottom: "80px",
    boxShadow: "0 0 19px 1px rgb(24 23 23 / 20%)",
    cursor: (p) => (p.animate ? "pointer" : "default"),
    animation: (p) =>
      p.animate
        ? () =>
            css`
              ${Blinker} 1s linear infinite
            `
        : null,
  },
});
const Blinker = keyframes`
  0% {
    box-shadow: 0px 7px 30px -10px var(--blue);
  }

  50% {
    box-shadow: 0px 7px 30px 10px var(--blue);
  }
 

`;
const Section1 = (props) => {
  const [animate, setAnimate] = useState(false);
  const [loginScActived, setLoginScActived] = useState(false);
  const [inputanimate, setInputanimate] = useState(1);
  const [btnAnimat, seBtnAnimate] = useState(false);
  const { isFa } = useContext(userContext);
  useEffect(() => {
    setTimeout(() => {
      setAnimate(true);
    }, 1500);
  }, []);

  useEffect(() => {
    if (animate) {
      setTimeout(() => setLoginScActived(true), 3000);
    }
  }, [animate]);
  const vocabs = (str) => {
    return returnStr(str, isFa);
  };
  return (
    <SHl bg={"white"} ai={"center"}>
      {loginScActived ? (
        <Sc1CnLogin animate={btnAnimat}>
          <img src={Logo} alt="" className="logo" />

          <div className="inputHolder">
            <span className="top">{vocabs("app_userId")}</span>
            <div className="in">
              <Typist
                onTypingDone={() => setInputanimate(2)}
                cursor={{
                  show: true,
                  blink: true,
                  element: "|",
                  hideWhenDone: true,
                  hideWhenDoneDelay: 1000,
                }}
              >
                {isFa ? "۵۰" : "50"}

                <Typist.Delay ms={300} />

                {isFa ? "۷" : "7"}
                <Typist.Delay ms={300} />

                {isFa ? "۹" : "9"}
                <Typist.Delay ms={300} />

                {isFa ? "۴۷" : "47"}
                <Typist.Delay ms={300} />

                {isFa ? "۲۳" : "23"}
              </Typist>

              <i className="icon username"></i>
            </div>
          </div>
          <div className="inputHolder">
            {inputanimate == 2 ? (
              <span className="top">{vocabs("app_password")}</span>
            ) : null}

            <div className="in">
              <i className="icon password"></i>
              {inputanimate == 2 ? (
                <Typist
                  onTypingDone={() => seBtnAnimate(true)}
                  cursor={{
                    show: true,
                    blink: true,
                    element: "|",
                    hideWhenDone: true,
                    hideWhenDoneDelay: 1000,
                  }}
                >
                  &#8226;&#8226;
                  <Typist.Delay ms={300} />
                  &#8226;
                  <Typist.Delay ms={300} />
                  &#8226;
                  <Typist.Delay ms={300} />
                  &#8226;&#8226;
                  <Typist.Delay ms={300} />
                  &#8226;&#8226;
                </Typist>
              ) : (
                <span className="top">{vocabs("app_password")}</span>
              )}

              {inputanimate == 2 ? (
                <i title={"Demo"} className="icon showpassword"></i>
              ) : null}
            </div>
          </div>
          <button
            onClick={() => {
              window.scrollTo(0, window.innerHeight);
            }}
            className="btn"
          >
            {vocabs("app_login")}
          </button>
        </Sc1CnLogin>
      ) : (
        <Sc1Cn>
          <motion.div
            className="motion"
            animate={{
              x: 0,
              y: animate ? -50 : 0,
              scale: animate ? 1.3 : 1,
              rotate: 0,
            }}
            transition={{ duration: animate ? 0.9 : 0 }}
          >
            <img src={Logo} alt="" className="logo" />
          </motion.div>

          <motion.div
            className="titleMotion"
            animate={{
              scale: animate ? 1 : 0,
              rotate: 0,
            }}
            transition={{ duration: animate ? 0.5 : 0 }}
          >
            <span>{vocabs("s1_title")}</span>
          </motion.div>

          <motion.div
            className="spanMotion"
            animate={{
              x: 0,
              y: animate ? 0 : 0,
              scale: animate ? 1 : 0,
              rotate: 0,
            }}
            transition={{ duration: animate ? 1.1 : 0 }}
          >
            <span className="span">
              {vocabs("app_monitor")}
              <br />
              {vocabs("app_power")}{" "}
            </span>
          </motion.div>

          <motion.div
            className="motion"
            initial={false}
            animate={{
              opacity: animate ? 0 : 1,
            }}
            transition={{ duration: animate ? 0.5 : 0 }}
          >
            <img src={Loading_gif} alt="" className="loading" />{" "}
          </motion.div>
        </Sc1Cn>
      )}
    </SHl>
  );
};

const Footer = styled.header({
  height: "35px",
  width: "calc( 100% - 30px )",
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",

  "& .btn": {
    height: "30px",
    width: "30px",
    borderRadius: 10,
    borderWidth: "1px",
    borderColor: "white",
    backgroundPosition: "center",
    backgroundSize: "contain",
    borderStyle: "solid",
    cursor: "pointer",
  },
  "& .right": {
    backgroundImage: `url(${menu})`,

    borderStyle: "none",
    borderRadius: "0px",
  },
  "& .left": {
    backgroundImage: `url(${bell})`,
  },
  "& .title": {
    flex: 1,

    "& span": {
      color: "white",
      fontFamily: "title",
      fontWeigth: "bold",
      textAlign: "center",
      width: "100%",
      display: "block",
      fontSize: "19px",
    },
  },
});

const HomeHolder = styled.div({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  width: "100%",
  flex: "1",

  "& .top": {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    fontFamily: "title",
    color: "white",
    marginTop: "10px",
    fontSize: 15,
    "& .value > span": {
      margin: "0 5px",
      display: "block",
      width: "65px",
    },
    "& .value ": {
      display: "flex",
      flexDirection: "row",
    },
  },
  "& .detail": {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    width: "calc(100% - 60px)",
    background: "white",
    borderRadius: "15px",
    padding: "10px 10px",
    marginTop: "20px",
    boxShadow: "0 0 19px 1px rgb(24 23 23 / 20%)",

    "& span": {
      color: "black",
      fontFamily: "title",
    },
    "& div": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "flex-start",
      flex: 1,
      "& .desc": {
        fontSize: "10px",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        maxWidth: "94px",
        overflow: "hidden",
        "& .value": {
          fontSize: "15px",
          marginLeft: "5px",
        },
      },
    },
    "& .line": {
      borderColor: "#d2d1d1",
      borderWidth: " 0 1px 0 0",
      borderStyle: "solid",
      height: "100%",
      margin: "0 0 0 10px",
    },
  },
  "& .chart": {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "calc(100% - 60px)",
    background: "white",
    borderRadius: "15px",
    padding: "10px 10px",
    marginTop: "20px",
    boxShadow: "0 0 19px 1px rgb(24 23 23 / 20%)",
    "& span": {
      fontFamily: "title",
      color: "black",
      fontSize: "17px",
    },
    "& .title": {
      fontSize: "14px",
      color: "#c0c0c0",
      margin: 0,
    },
    "& .cn": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      marginTop: "10px",
      position: "relative",
      borderRadius: "0",
      "& .bar": {
        width: "100%",
        height: "10px",
        background: "var(--back)",
        borderRadius: "5px",
        "&:after": {
          content: ' ""',
          width: (p) => p.percent,
          height: "10px",
          position: "absolute",
          background: (p) => p.chartColor,
          borderRadius: "5px",
          transition: "all 500ms ease-in",
        },
        // animation: (p) =>
        // p.animate
        //   ? () =>
        //       css`
        //         ${Blinker2} 1s linear infinite
        //       `
        //   : null,
      },
      "& .spans": {
        display: "flex",
        flexDirection: "row",
        width: "100%",
        marginTop: 3,
        fontSize: "12px",
        "& .left": {
          textAlign: "left",
          marginRight: "2px",
        },
      },
      "& span": {
        fontSize: "12px",
        color: "#c8c8c8",
        display: "block",
        flex: 1,
      },
    },
  },

  "& .btn": {
    height: "40px",
    fontFamily: "title",
    fontWeight: "bold",
    color: "white",
    marginTop: "7vh",
    borderRadius: 15,
    borderStyle: "solid",
    borderWidth: "1px",
    padding: "0px 40px 0 40px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    cursor: (p) => (p.animate ? "pointer" : "default"),

    "& i": {
      content: ' ""',
      width: "12px",
      height: "12px",
      marginLeft: "5px",
      backgroundImage: `url(${signal})`,
      backgroundPosition: "center",
      backgroundSize: "contain",
      right: "20px",
      marginBottom: "7px",
    },
    "& span": {
      textAlign: "center",
    },
  },
});

const Blinker2 = keyframes`
  0% {
    box-shadow: 0px 7px 30px -10px var(--red);
  }

  50% {
    box-shadow: 0px 7px 30px 10px var(--red);
  }
 

`;

const Section2 = (props) => {
  const [value, setValue] = useState({
    current: 21,
    voltage: 220,
    currentUsage: 10.01,
    usage: 0,
    chartColor: "var(--green)",
    background: "var(--blue)",
    usageStep: 1,
    min: 0,
    max: 100,
    price: 1.2,
  });
  const [effected, setEffected] = useState(false);
  const [counterFinished, setCounterFinished] = useState(false);
  const { isFa } = useContext(userContext);

  useEffect(() => {
    if (!effected) {
      setEffected(true);
      let _int = setInterval(() => {
        if (valueReturner(value)) {
          setCounterFinished(true);
          clearInterval(_int);
        }
      }, 1500);
    }
  }, [effected, value, counterFinished]);

  const valueReturner = (v) => {
    let random = 0.56;
    let _value;
    setValue((pre) => {
      let _step = stepReturner(parseFloat(pre.usage) + random * 100);
      _value = parseFloat(pre.usage) + random * 100;

      return {
        current: (20 + random).toFixed(2),
        voltage: (220 + random * 10).toFixed(0),
        currentUsage: (random * 10).toFixed(2),
        usage: (parseFloat(pre.usage) + random * 100).toFixed(2),
        chartColor: _step.chartColor,
        backgroundColor: colorChanger(
          _step.background,
          _step.min,
          (parseFloat(pre.usage) + random * 100).toFixed(2)
        ),
        usageStep: 1,
        min: _step.min,
        max: _step.max,
        price: _step.price,
      };
    });
    if (_value > 550) return true;
    return false;
  };

  const stepReturner = (value) => {
    let _step;

    if (0 < value && value < 100) {
      _step = {
        min: 0,
        max: 100,
        background: "rgb(41, 171, 226)",
        chartColor: "rgb(30, 250 ,129)",
        price: 1.2,
      };
    } else if (100 < value && value < 200) {
      _step = {
        min: 100,
        max: 200,
        background: "rgb(0, 156, 222)",
        chartColor: "rgb(20 ,205 ,104)",
        price: 1.2,
      };
    } else if (200 < value && value < 300) {
      _step = {
        min: 200,
        max: 300,
        background: "rgb(249, 161, 30)",
        chartColor: "rgb(249, 161, 30)",
        price: 1.2,
      };
    } else if (300 < value && value < 400) {
      _step = {
        min: 300,
        max: 400,
        background: "rgb(241, 90 ,36)",
        chartColor: "rgb(241, 90 ,36)",
        price: 1.2,
      };
    } else if (400 < value && value < 500) {
      _step = {
        min: 400,
        max: 500,
        background: "rgb(249, 65 ,0)",
        chartColor: "rgb(249, 65 ,0)",
        price: 1.2,
      };
    } else if (500 < value) {
      _step = {
        min: 500,
        max: 600,
        background: "rgb(240, 56 ,93)",
        chartColor: "rgb(240, 56 ,93)",
        price: 1.2,
      };
    }
    return _step;
  };

  const colorChanger = (bgColor, min, v) => {
    let _step;
    let _c;
    let _value = v - min;
    if (bgColor == "rgb(41, 171, 226)") {
      _c = "rgb(0, 156, 222)";
    } else if (bgColor == "rgb(0, 156, 222)") {
      _c = "rgb(249, 161, 30)";
    } else if (bgColor == "rgb(249, 161, 30)") {
      _c = "rgb(241, 90 ,36)";
    } else if (bgColor == "rgb(241, 90 ,36)") {
      _c = "rgb(249, 65 ,0)";
    } else if (bgColor == "rgb(249, 65 ,0)") {
      _c = "rgb(240, 56 ,93)";
    } else if (bgColor == "rgb(240, 56 ,93)") {
      _c = "rgb(240, 56 ,93)";
    }

    let _b = bgColor
      .substring(bgColor.lastIndexOf("(") + 1, bgColor.lastIndexOf(")"))
      .split(",");
    let _car = _c
      .substring(_c.lastIndexOf("(") + 1, _c.lastIndexOf(")"))
      .split(",");

    let distance = [_b[0] - _car[0], _b[1] - _car[1], _b[2] - _car[2]];
    let rgb = `rgb(
      ${parseInt(_b[0]) + (distance[0] * _value) / 100} ,
      ${parseInt(_b[1]) + (distance[1] * _value) / 100} ,
      ${parseInt(_b[2]) + (distance[2] * _value) / 100} )`;
    props.changeStatusBar(rgb);
    return rgb;
  };
  const vocabs = (str) => {
    return returnStr(str, isFa);
  };
  return (
    <SHl bg={value.backgroundColor} ai={"center"}>
      <Footer>
        <div className="btn right"></div>
        <div className="title">
          <span>{vocabs("s1_title")}</span>
        </div>
        <div className="btn left"></div>
      </Footer>
      <HomeHolder
        percent={`${value.usage - value.min}%`}
        chartColor={value.chartColor}
        animate={counterFinished}
      >
        <div className="top">
          <span className="top">{vocabs("app_currentUsage")}</span>
          <span className="midlle">
            {isFa ? persianReturner(value.currentUsage) : value.currentUsage}
          </span>
          <div className="value">
            <span className="current">
              {" "}
              {isFa ? persianReturner(value.current) : value.current}{" "}
              {vocabs("app_amperUnit")}
            </span>
            <i style={{ fontStyle: "normal" }}> |</i>
            <span className="voltaj">
              {" "}
              {isFa ? persianReturner(value.voltage) : value.voltage}
              {vocabs("app_voltUnit")}{" "}
            </span>
          </div>
        </div>

        <div className="detail">
          <div className="right">
            <span className="top">{vocabs("app_periodUsage")}</span>
            <span className="desc">
              <span className="value">
                {isFa ? persianReturner(value.usage) : value.usage}
              </span>
              {vocabs("app_kwh")}{" "}
            </span>
          </div>

          <i
            style={{ margin: isFa ? "0 0 0 10px" : "0 10px 0 0 " }}
            className="line"
          ></i>

          <div className="left">
            <span className="top">{vocabs("app_cost")}</span>
            <span className="desc">
              <span className="value">
                {isFa
                  ? persianReturner((value.usage * value.price).toFixed(1))
                  : (value.usage * value.price).toFixed(1)}
              </span>
              {vocabs("app_priceUnit")}
            </span>
          </div>
        </div>

        <div className="chart">
          <span className="title">{vocabs("app_status")}</span>
          <span className="desc"> {vocabs("app_customerStatus")}</span>

          <div className="cn">
            <div className="bar"></div>
            <div className="spans">
              <span className="right">
                {persianReturner(value.min)} {vocabs("app_kwh")}
              </span>

              {value.max == 600 ? (
                <span className="left">&#8734; {vocabs("app_kwh")}</span>
              ) : (
                <span className="left">
                  {persianReturner(value.max)} {vocabs("app_kwh")}
                </span>
              )}
            </div>
          </div>
        </div>

        <div className="btn">
          <i style={{ margin: isFa ? "0 0 7px 5px" : "0 5px 7px 0" }}></i>

          <span>{vocabs("app_moreDetail")}</span>
        </div>
      </HomeHolder>
    </SHl>
  );
};

const Notification = styled.div({
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  width: "calc(100% - 40px)",
  borderRadius: "15px 2px 15px 15px",
  background: "white",
  boxShadow: "-1px 16px 20px 0px rgb(24 23 23 / 20%)",
  position: "absolute",
  top: "1px",
  padding: "15px 10px",
  fontFamily: "title",
  fontSize: "15px",

  "& .spanTop": {
    marginTop: "15px",
    color: "balck",
  },
  "& .sapnDesc": {
    color: "black",
    opacity: "0.6",
    textAlign: "justify",
    fontSize: 13,
  },
  "&:after": {
    content: ' ""',
    width: "20px",
    height: "20px",
    backgroundImage: `url(${Logo})`,
    backgroundPosition: "center",
    backgroundSize: "contain",
    position: "absolute",
    top: "10px",
    left: "10px",
    filter: "drop-shadow(0px 0px 5px var(--blue));",
  },
  "&:before": {
    content: ' ""',
    width: "20px",
    height: "20px",
    backgroundImage: `url(${Close})`,
    backgroundPosition: "center",
    backgroundSize: "contain",
    position: "absolute",
    top: "5px",
    right: "5px",
    filter: "drop-shadow(0px 0px 5px var(--blue))",
    opacity: "0.6",
    cursor: "pointer",
  },
});
const Section3 = (props) => {
  const [value, setValue] = useState({
    current: 21.4,
    voltage: 220.4,
    currentUsage: 22,
    usage: 569,
    chartColor: "var(--red)",
    background: "var(--red",
    usageStep: 5,
    min: 500,
    max: 600,
    price: 1.2,
  });
  const { isFa } = useContext(userContext);

  const [effected, setEffected] = useState(false);
  const [counterFinished, setCounterFinished] = useState(false);
  const [closeBtn, setCloseBtn] = useState(true);
  useEffect(() => {
    if (!effected) {
      setEffected(true);
      let _timer = setTimeout(() => {
        setCounterFinished(true);
        clearTimeout(_timer);
      }, 1000);
    }
  }, []);
  const vocabs = (str) => {
    return returnStr(str, isFa);
  };
  return (
    <SHl bg={"var(--red)"} ai={"center"}>
      <Footer>
        <div className="btn right"></div>
        <div className="title">
          <span>{vocabs("s1_title")}</span>
        </div>
        <div className="btn left"></div>
      </Footer>
      <HomeHolder
        percent={`${value.usage - value.min}%`}
        chartColor={value.chartColor}
        animate={counterFinished}
      >
        <motion.div
          style={{ width: "100%" }}
          animate={{
            y: !counterFinished ? 0 : 0,
            x: !counterFinished ? 0 : closeBtn ? 0 : 500,
            opacity: !counterFinished ? 0 : 1,
            scale: !counterFinished ? 0 : 1,
          }}
          transition={{ ease: "easeOut", duration: 0.7 }}
          initial={{
            y: !counterFinished ? 0 : -105,
            x: !counterFinished ? 0 : 50,
            opacity: !counterFinished ? 0 : 0.8,
            scale: 0.8,
          }}
        >
          <Notification
            onClick={() => {
              setCloseBtn(false);
            }}
            className="notification"
          >
            <span className="spanTop">{vocabs("app_dearCustomer")} </span>
            <span className="sapnDesc">{vocabs("app_notification")} </span>
          </Notification>
        </motion.div>

        <div className="top">
          <span className="top">{vocabs("app_currentUsage")}</span>
          <span className="midlle">
            {isFa ? persianReturner(value.currentUsage) : value.currentUsage}
          </span>
          <div className="value">
            <span className="current">
              {" "}
              {isFa ? persianReturner(value.current) : value.current}{" "}
              {vocabs("app_amperUnit")}{" "}
            </span>
            <i style={{ fontStyle: "normal" }}> |</i>
            <span className="voltaj">
              {" "}
              {isFa ? persianReturner(value.voltage) : value.voltage}
              {vocabs("app_voltUnit")}{" "}
            </span>
          </div>
        </div>

        <div className="detail">
          <div className="right">
            <span className="top">{vocabs("app_periodUsage")}</span>
            <span className="desc">
              <span className="value">
                {isFa ? persianReturner(value.usage) : value.usage}
              </span>
              {vocabs("app_kwh")}{" "}
            </span>
          </div>

          <i
            style={{ margin: isFa ? "0 0 0 10px" : "0 10px 0 0 " }}
            className="line"
          ></i>

          <div className="left">
            <span className="top">{vocabs("app_cost")}</span>
            <span className="desc">
              <span className="value">
                {isFa
                  ? persianReturner((value.usage * value.price).toFixed(1))
                  : (value.usage * value.price).toFixed(1)}
              </span>
              {vocabs("app_priceUnit")}
            </span>
          </div>
        </div>

        <div className="chart">
          <span className="title">{vocabs("app_status")}</span>
          <span className="desc"> {vocabs("app_customerStatus")}</span>

          <div className="cn">
            <div className="bar"></div>
            <div className="spans">
              <span className="right">
                {persianReturner(value.min)} {vocabs("app_kwh")}
              </span>

              {value.max == 600 ? (
                <span className="left">&#8734; {vocabs("app_kwh")}</span>
              ) : (
                <span className="left">
                  {persianReturner(value.max)} {vocabs("app_kwh")}
                </span>
              )}
            </div>
          </div>
        </div>

        <div className="btn">
          <i style={{ margin: isFa ? "0 0 7px 5px" : "0 5px 7px 0" }}></i>

          <span>{vocabs("app_moreDetail")}</span>
        </div>
      </HomeHolder>
    </SHl>
  );
};

const Sc4 = styled.div({
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  flex: 1,
  width: "100%",
  "& .header": {
    width: "100%",
    height: 50,
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    background: "var(--blue)",
    "& i": {
      width: "20px",
      height: "20px",
      background: `url(${Left})`,
      backgroundPosition: "center",
      backgroundSize: "contain",
      margin: "0 10px",
      cursor: "no-drop",
    },
    "& span": {
      fontFamily: "title",
      color: "white",
      fontWeight: "bold",
      fontSize: "18px",
      margin: "0 10px ",
      flex: 1,
    },
  },
});
const Section4 = (props) => {
  const [chart, setchart] = useState({
    series: [
      {
        name: "جریان",
        data: [1, 2, 3],
      },
    ],
    options: {
      xaxis: {
        type: "datetime",
        categories: [1, 2, 3],
        stroke: { curve: "stepline" },
        dataLabels: { enabled: false },
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.7,
            opacityTo: 0.9,
            stops: [0, 90, 100],
          },
        },
      },
    },
  });
  const { isFa } = useContext(userContext);

  const vocabs = (str) => {
    return returnStr(str, isFa);
  };
  return (
    <SHl bg={"white"} ai={"center"}>
      <Sc4>
        <div className="header">
          <span>{vocabs("app_analyze")}</span>
          <i
            style={{ transform: isFa ? "rotate(0deg)" : "rotate(180deg)" }}
          ></i>
        </div>
        <div className="cn">
          <Chart
            options={chart.options}
            series={chart.series}
            height={300}
            width={280}
            type="area"
          />
        </div>
      </Sc4>
    </SHl>
  );
};

const Box = styled.div({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  height: "100px",
  maxWidth: "100px",
  width: "29%",
  margin: "5px",
  background: "white",
  transition: "2000ms",
  borderRadius: "15px",
  boxShadow: "0 0 19px 1px rgb(24 23 23 / 20%)",
  cursor: (p) => (p.onClick ? "pointer" : "default"),
  "& img": {
    height: "30px",
    transition: "200ms",
  },
  "& .name": {
    fontFamily: "title",
    marginTop: "5px",
    marginBottom: "0",
    fontSize: "14px",
  },
  "& .value": {
    fontFamily: "title",
    fontSize: "12px",
    color: "gray",
  },
});
const Sc5 = styled.div({
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  flex: 1,
  width: "100%",

  "& .header": {
    width: "100%",
    height: 40,
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    background: "var(--blue)",
    "& i": {
      width: "20px",
      height: "20px",
      background: `url(${Left})`,
      backgroundPosition: "center",
      backgroundSize: "contain",
      margin: "0 10px",
      cursor: "no-drop",
    },
    "& span": {
      fontFamily: "title",
      color: "white",
      fontWeight: "bold",
      fontSize: "18px",
      margin: "0 10px ",
      flex: 1,
    },
  },
  "& .cn": {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    background: "var(--back)",
    width: "calc( 100% - 20px)",
    flexWrap: "wrap",
    padding: "10px",
  },
});
const Section5 = (props) => {
  const [lamp, setLamp] = useState(false);
  const [split, setSplit] = useState(false);
  const [sensor, setSensor] = useState({ h: 80, c: 10, t: 20 });
  const [effected, setEffected] = useState(false);
  const vocabs = (str) => {
    return returnStr(str, isFa);
  };
  const { isFa } = useContext(userContext);

  useEffect(() => {
    if (!effected) {
      setEffected(true);
      let timer = setInterval(() => {
        let rnd = Math.random().toFixed(2) * 10;
        setSensor({ h: 80 + rnd, c: 10 + rnd, t: 20 + rnd });
      }, 2000);
    }
  });
  return (
    <Sc5 style={{ direction: isFa ? "rtl" : "ltr" }}>
      <div className="header">
        <span>{vocabs("s5_title")}</span>
        <i style={{ transform: isFa ? "rotate(0deg)" : "rotate(180deg)" }}></i>
      </div>
      <div className="cn">
        <Box
          onClick={() => {
            setLamp(!lamp);
          }}
        >
          <img src={lamp ? OnLamp : OffLamp} alt="" />
          <span className="name">{vocabs("lamp")}</span>
          <span className="value">{lamp ? vocabs("on") : vocabs("off")}</span>
        </Box>
        <Box
          onClick={() => {
            setSplit(!split);
          }}
        >
          <img style={{ opacity: split ? "1" : "0.4" }} src={Fan} alt="" />
          <span className="name">{vocabs("split")}</span>
          <span className="value">{split ? vocabs("on") : vocabs("off")}</span>
        </Box>
        <Box>
          <img src={Humidity} alt="" />
          <span className="name">{vocabs("humidity")}</span>
          <span className="value">{sensor.h.toFixed(1)}%</span>
        </Box>
        <Box>
          <img src={CO2} alt="" />
          <span className="name">{vocabs("co2")}</span>
          <span className="value">{sensor.c.toFixed(1)}ppm</span>
        </Box>
        <Box>
          <img src={InsideTemp} alt="" />
          <span className="name">{vocabs("temp")}</span>
          <span className="value">{sensor.t.toFixed(1)}c</span>
        </Box>
      </div>
    </Sc5>
  );
};

const ContactUsHolder = styled.section({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  height: "100vh",
  scrollSnapAlign: "center",
  "& .top": {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    flex: 1,
    "& span": {
      fontFamily: "title",
      fontSize: "25px",
      fontWeight: "bold",
    },
    "& form": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      "& input": {
        border: "none",
        width: "100%",
        borderRadius: "15px",
        background: "var(--back)",
        height: "40px",
        margin: "5px 0",
        maxWidth: "400px",
        fontFamily: "title",
        fontWeight: "bold",
        textAlign: "center",
        fontSize: "16px",
        width: "calc( 100% - 20px )",
      },
      "& textarea": {
        border: "none",
        width: "calc( 100% - 40px )",
        borderRadius: "15px",
        background: "var(--back)",
        height: "80px",
        margin: "5px 0",
        maxWidth: "400px",
        fontFamily: "title",
        fontWeight: "bold",
        textAlign: "center",
        fontSize: "16px",
        padding: "10px",
      },
      "& .btn": {
        border: "none",
        width: "calc( 100% - 20px )",
        borderRadius: "15px",
        background: "var(--pentomi)",
        height: "50px",
        margin: "10px 0",
        maxWidth: "430px",
        fontFamily: "title",
        fontWeight: "bold",
        textAlign: "center",
        fontSize: "16px",
        padding: "10px",
        color: "white",
        cursor: "pointer",
      },
    },
  },
  "& .footer": {
    width: "100%",
    height: "90px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    paddingBottom: "10px",
    "& hr": {
      background: "var(--back)",
    },
    "& span": {
      fontFamily: "title",
      fontWeight: "bold",
      color: "var(--gray)",

      margin: "10px 0",
      display: "block",
      textAlign: "center",
    },
    "& .instagram": {
      display: "inline-block",
      width: "25px",
      height: "25px",
      textAlign: "center",
      borderRadius: "5px",
      color: "#fff",
      fontSize: "220px",
      lineHeight: "250px",
      verticalAlign: "middle",
      background: "#d6249f",
      background:
        "radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%,#d6249f 60%,#285AEB 90%)",
      boxShadow: "0px 3px 10px rgba(0,0,0,.25)",
      cursor: "pointer",
    },
    "& .callTous": {
      fontFamily: "title",
      color: "black",
      margin: "0 10px",
      textDecoration: "none",
    },
  },
});
const ContactUs = ({ id, style }) => {
  const [submited, setSubmited] = useState(false);
  const { isFa } = useContext(userContext);

  const vocabs = (str) => {
    return returnStr(str, isFa);
  };
  return (
    <ContactUsHolder style={style} id={id}>
      <div className="top">
        <span className="title">{vocabs("contactUs")}</span>
        <form
          onSubmit={() => {
            setSubmited(true);
          }}
          method="post"
          target="dummyframe"
          action="https://nirooban.com/form"
        >
          <iframe
            name="dummyframe"
            id="dummyframe"
            style={{ display: "none" }}
          ></iframe>

          <input
            required
            placeholder={vocabs("name")}
            name="name"
            type="text"
          />
          <input
            required
            placeholder={vocabs("phoneNumber")}
            name="phone"
            type="text"
          />
          <input placeholder={vocabs("city")} name="city" type="text" />
          <input
            required
            placeholder={vocabs("subject")}
            name="subject"
            type="text"
          />
          <input
            required
            placeholder={vocabs("email")}
            name="email"
            type="email"
          />
          <textarea
            required
            placeholder={vocabs("text")}
            name="cm"
            id=""
            cols="30"
            rows="10"
          ></textarea>
          <input
            style={{ background: submited ? "var(--green)" : "var(--pentomi)" }}
            className="btn"
            type="submit"
            value={!submited ? vocabs("sendPm") : vocabs("sentPm")}
          />
        </form>
      </div>
      <div className="footer">
        <hr width="80%" height="2px" />
        <span>{vocabs("copyright")}</span>
        <div className="icon">
          <i
            onClick={() => {
              window.location.href = "https://www.instagram.com/nirooban.co/";
            }}
            class="instagram"
          >
            <i class="fa fa-instagram"></i>
          </i>

          <a href="tel:+989368819962" className="callTous">
            {vocabs("whatsapp")}
          </a>
        </div>
      </div>
    </ContactUsHolder>
  );
};

const Sd = styled.div({
  position: "absolute",
  top: "calc(100% - 70px)",
  left: "calc(50% - 25px)",
  height: "50px",
  width: "50px",
  borderRadius: "50px",
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  boxShadow: "var(--shadow)",
});
const ScrollDown = ({ color, id }) => {
  return (
    <Sd
      onClick={() => {
        window.location.replace(`/#${parseInt(id) + 1}`);
      }}
      style={{ background: color }}
    >
      <div className="arroww"></div>
    </Sd>
  );
};
export {
  Holder,
  SmartHome,
  Main,
  Cn,
  GetPhoneNumber,
  Mobile,
  Dots,
  Iot,
  HalfMobile,
  Warning,
  Section1,
  Section2,
  Section3,
  Section4,
  Section5,
  ContactUs,
  ScrollDown,
};
